import React from "react";
import { confirmDialog } from "primereact/confirmdialog";

interface ConfirmButtonProps {
	label: string;
	icon?: string;
	message: string;
	header: string;
	acceptClassName?: string;
	rejectClassName?: string;
	acceptLabel?: string;
	rejectLabel?: string;
	onConfirm: () => void;
}

const ConfirmButton: React.FC<ConfirmButtonProps> = ({
	label,
	icon,
	message,
	header,
	acceptClassName,
	rejectClassName,
	acceptLabel = "Delete",
	rejectLabel = "Cancel",
	onConfirm,
}) => {
	const handleAccept = () => {
		onConfirm();
	};

	const handleReject = () => {
		return null;
	};

	const showConfirmDialog = () => {
		confirmDialog({
			message: <div className="text-black my-2">{message} </div>,
			header: (
				<div className="absolute w-full top-3 left-3 font-bold text-lg text-gray-800 mb-3 ml-3 flex ">
					{header}
				</div>
			),
			icon: <i className={`${icon || "pi pi-info-circle"} text-blue-500`} />,
			acceptClassName: `${
				acceptClassName || ""
			} bg-[#438437] text-white hover:scale-110 transition duration-300 ease-in-out py-2 px-3 rounded-lg text-md mt-3 flex-end`,
			rejectClassName: `${
				rejectClassName || ""
			} bg-black text-white  py-2 px-3 rounded-lg text-md mt-3 flex-end mx-3 hover:scale-110 transition duration-300 ease-in-out`,
			position: "center",
			accept: handleAccept,
			reject: handleReject,
			acceptLabel,
			rejectLabel,
			className: "p-4 bg-white border rounded-xl flex flex-col items-end ",
		});
	};

	return (
		<button
			onClick={showConfirmDialog}
			className="cursor-pointer p-1 text-sm rounded-md hover:scale-110 transition duration-300 ease-in-out flex items-center justify-center"
		>
			{label ? (
				label
			) : (
				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M4.5835 6.25V16.6667C4.5835 16.9982 4.71519 17.3161 4.94961 17.5505C5.18403 17.785 5.50198 17.9167 5.8335 17.9167H15.0002C15.3317 17.9167 15.6496 17.785 15.884 17.5505C16.1185 17.3161 16.2502 16.9982 16.2502 16.6667V6.25H4.5835Z"
						stroke="black"
					/>
					<path
						d="M7.0835 8.67499V15.4917M10.4168 8.67499V15.4917M13.7502 8.67499V15.4917M7.50016 3.61082V2.70332C7.50016 2.13082 8.02266 1.66666 8.66683 1.66666H12.1668C12.811 1.66666 13.3335 2.13082 13.3335 2.70332V3.61166"
						stroke="black"
						strokeLinecap="round"
					/>
					<path
						d="M16.6667 3.75H4.16675C3.47639 3.75 2.91675 4.30964 2.91675 5C2.91675 5.69036 3.47639 6.25 4.16675 6.25H16.6667C17.3571 6.25 17.9167 5.69036 17.9167 5C17.9167 4.30964 17.3571 3.75 16.6667 3.75Z"
						stroke="black"
					/>
				</svg>
			)}
		</button>
	);
};

export default ConfirmButton;
